import { createSelector } from '@/store/utils';
import { IAppState } from '@/store/root-reducer';
import { CustomNotificationsType, IAppSetup } from './app-config.reducer';

const appConfigSelector = (state: IAppState) => state.appConfig;

export const getAppState = (state: IAppState) => state;

const appSetupKeySelector =
    <K extends keyof IAppSetup>(setupKey: K) =>
    (state: IAppState): IAppSetup[K] =>
        appConfigSelector(state).appSetup[setupKey];

export const getMobileConfig = (state: IAppState) => state.appConfig.mobile;

export const getLayoutConfig = (state: IAppState) => state.appConfig.layoutConfig;

export const getSeo = (state: IAppState) => state.appConfig.seo;

export const getTopBanner = (state: IAppState) => state.appConfig.topBanner;

export const getAppSetup = (state: IAppState) => state.appConfig.appSetup;

export const getIsCrawlerBot = (state: IAppState) => state.appConfig.appSetup.isCrawlerBot;

export const getCookieBarState = (state: IAppState) => state.appConfig.appSetup.shouldShowCookieBar;

export const getScrolledToBottom = (state: IAppState) => state.appConfig.global.scrolledBottom;

export const getCustomNotifications = (state: IAppState, type: CustomNotificationsType) =>
    state.appConfig.customNotifications[type] || [];

export const getResponseState = (state: IAppState) => state.appConfig.responseState.isResponseSuccess;

export const getServerHttpStatus = (state: IAppState) => state.appConfig.responseState.serverHttpStatus;

export const getOriginSelector = appSetupKeySelector('appLocationOrigin');

export const getPathnameSelector = appSetupKeySelector('appLocationPathname');

export const getAppLocation = createSelector(getOriginSelector, getPathnameSelector, (origin, pathname) => ({
    origin,
    pathname,
}));

export const getSelectedHomepage = (state: IAppState) => state.appConfig.appSetup.selectedHomepage;

export const getSelectedLanguage = (state: IAppState) => state.appConfig.appSetup.selectedLanguage;

export const getRehydratedStatus = (state: IAppState) => state.appConfig.appSetup.rehydrated;

export const isSafariBrowser = (state: IAppState) => state.appConfig.appUserAgent.isSafariBrowser;
